import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import appConfig from '../../constants/appConfig'
const AboutPage = () => {
  return (
    <div className='card mb-5 mb-xl-10'>
      <PageTitle>About Us</PageTitle>
      <div className='card-header'>
        <div className='card-title'>
          <h3 className='fw-bolder'>About</h3>
        </div>
      </div>

      <div className='collapse show'>
        <div className='card-body border-top '>
          <p>
            {appConfig.appFullName} improves business outcomes using our predictive measures,
            metrics and models. Learn more at{' '}
            <a href='https://www.pointleader.us' rel='nofollow'>
              https://www.pointleader.us
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
